import { useEffect, useMemo } from "react";
import { ListData_ValueTypes } from "../../../../../Definitions";
import { GenericDeviceTable } from "../../../../../Components";
import { LC_SYSTEM, LCSystemArgs, LCSystemResponse } from "../../../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/lcSystem";
import { useLazyQuery } from "@apollo/client";
import { useAicoConnection } from "../../../../../Components/ToolsComponents/_ToolsComponents/aicoConnectionContext";

const columnsData = [
	{ headerValue: "ID", accessor: "id", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "feed_day_start", accessor: "feed_day_start", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "fk_system_types", accessor: "fk_system_types", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "pw_sources", accessor: "pw_sources", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "programmed", accessor: "programmed", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "min_feed_speed", accessor: "min_feed_speed", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "max_feed_speed", accessor: "max_feed_speed", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "default_amount", accessor: "default_amount", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "boot_time", accessor: "boot_time", type: ListData_ValueTypes.Date, sort: true },
]

export default function SystemDataTable() {
	const { state: connectionState } = useAicoConnection();
	
	const [fetchData, {data, loading, error }] = useLazyQuery<LCSystemResponse, LCSystemArgs>(LC_SYSTEM, { fetchPolicy: "network-only" });

	useEffect(() => {
		if (connectionState.deviceConnection) {
			fetchData({variables: connectionState.deviceConnection});
		}
	}, [connectionState.deviceConnection]);

	const tableData = useMemo(() => {
		return data?.controller.lcSystem?.map((e, i) => ({
			...e,
			id: i,
			boot_time: new Date(e.boot_time * 1000),
		})) ?? [];
	}, [data]);

	return (
		<GenericDeviceTable
			title="Systems"
			columnsData={columnsData}
			data={tableData}
			loading={loading}
			error={error}
			onFetch={() => connectionState.deviceConnection && fetchData({ variables: connectionState.deviceConnection })}
		/>
	)
}